import { useContext, ReactElement } from 'react'

// Functions
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import { GlobalContext } from 'context/GlobalContextProvider'

// Styles
import breakpoints from '@/assets/theme/breakpoints'
import classes from './TermsOfUse-CSS'

export default function TermsOfUse() {
  const { t } = useTranslation('termsOfUse')
  const { screenDimensions } = useContext(GlobalContext)

  const h3 = (text: string) => (
    <Typography
      variant="h3"
      sx={classes.h3}
      style={{
        fontSize:
          screenDimensions.width > breakpoints.mobileSmall
            ? '1.1rem'
            : '0.95rem'
      }}
    >
      {text}
    </Typography>
  )

  const b2 = (text: string | ReactElement) => (
    <Typography
      variant="body1"
      sx={classes.b2}
      style={{
        fontSize:
          screenDimensions.width > breakpoints.mobileSmall
            ? '0.93rem'
            : '0.85rem'
      }}
    >
      {text}
    </Typography>
  )

  return (
    <Box sx={classes.mainDiv}>
      <Box
        sx={classes.sndDiv}
        style={{
          minHeight: screenDimensions.height - 220
        }}
      >
        <Typography
          variant="h1"
          sx={classes.h1}
          style={{
            fontSize:
              screenDimensions.width > breakpoints.mobileSmall
                ? '2rem'
                : '1.5rem'
          }}
        >
          {t('h1')}
        </Typography>
        <Typography variant="body1" sx={classes.b1}>
          {t('version')}
        </Typography>
        <Typography
          variant="body1"
          sx={classes.b1}
          style={{ marginBottom: '1.5rem' }}
        >
          {t('update')}
        </Typography>

        <section>
          {h3(t('termsOfUse.applicability.title'))}
          {b2(t('termsOfUse.applicability.body1'))}
          {b2(t('termsOfUse.applicability.body2'))}
          {b2(t('termsOfUse.applicability.body3'))}
        </section>

        <section>
          {h3(t('termsOfUse.accessRestrictions.title'))}
          {b2(t('termsOfUse.accessRestrictions.body'))}
          {b2(t('termsOfUse.accessRestrictions.body2'))}
          {b2(t('termsOfUse.accessRestrictions.body3'))}
          {b2(t('termsOfUse.accessRestrictions.body4'))}
        </section>

        <section>
          {h3(t('termsOfUse.legalAdvice.title'))}
          {b2(t('termsOfUse.legalAdvice.body'))}
          {b2(t('termsOfUse.legalAdvice.body2'))}
          {b2(t('termsOfUse.legalAdvice.body3'))}
        </section>

        <section>
          {h3(t('termsOfUse.permissible.title'))}
          {b2(t('termsOfUse.permissible.body'))}
          {b2(t('termsOfUse.permissible.body2'))}
        </section>

        <section>
          {h3(t('termsOfUse.intellectualProperty.title'))}
          {b2(t('termsOfUse.intellectualProperty.body'))}
          {b2(t('termsOfUse.intellectualProperty.body2'))}
        </section>

        <section>
          {h3(t('termsOfUse.disclaimerOfWarranties.title'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body1'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body2'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body22'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body3'))}
          {b2(t('termsOfUse.disclaimerOfWarranties.body33'))}
        </section>

        <section>
          {h3(t('termsOfUse.limitationOfLiability.title'))}
          {b2(t('termsOfUse.limitationOfLiability.body'))}
          {b2(t('termsOfUse.limitationOfLiability.body1'))}
          {b2(t('termsOfUse.limitationOfLiability.body2'))}
          {b2(t('termsOfUse.limitationOfLiability.body22'))}
        </section>

        <section>
          {h3(t('termsOfUse.dataProtection.title'))}
          {b2(t('termsOfUse.dataProtection.body'))}
        </section>

        <section>
          {h3(t('termsOfUse.externalLinks.title'))}
          {b2(t('termsOfUse.externalLinks.body'))}
          {b2(t('termsOfUse.externalLinks.body2'))}
        </section>

        <section>
          {h3(t('termsOfUse.finalProvisions.title'))}
          {b2(t('termsOfUse.finalProvisions.body'))}
          {b2(t('termsOfUse.finalProvisions.body1'))}
          {b2(t('termsOfUse.finalProvisions.body2'))}
          {b2(t('termsOfUse.finalProvisions.body22'))}
          {b2(t('termsOfUse.finalProvisions.body3'))}
          {b2(t('termsOfUse.finalProvisions.body33'))}
          {b2(t('termsOfUse.finalProvisions.body4'))}
          {b2(t('termsOfUse.finalProvisions.body44'))}
        </section>
      </Box>
    </Box>
  )
}
